<template>
  <div class="container mt-3">
    <div v-if="rights.rapport.eval_prix_ooftop" class="row bg-blue bigText evalBlock mb-3">
      <div class="col-md-4 evalTitle">
        <h3 v-if="value.trames.length" style="color:#192839;">{{$t("Evaluation avec analyse")}}</h3>
        <h3 v-else>{{$t("Evaluation ooftop")}}</h3>
      </div>
      <div class="col-md-4">
        <a class="hight" @click="$bvModal.show('modal-ae')" v-if="value.trames.length"><span class="material-icons">help_outline</span> {{$t("L'analyse de l'évaluateur Ooftop")}}</a>
      </div>
      <div class="col-md-4 text-right" v-if="!value.trames.length">
        <span>{{$t("Indice de confiance")}}</span>
        <span v-if="value.indice !== null"><Gauge :value="value.indice"/></span><span v-else class="small">{{nodata}}</span>
      </div>            
      <div class="col-md-3 statB bg-dark bb br">
        <b v-if="value.trames.length">{{$t("Evaluation algorithme Ooftop")}}</b>
        <b v-else>{{$t("Prix estimé")}}</b>
        <h2 v-if="value.trames.length" style="color:#192839;font-weight:bold;">{{ value.trames[2].label.replace('Prix : ','').replace('€','') }}</h2>
        <h2 v-else>{{$t("$")}} {{ format_number(value.estimation) }} {{$t("€")}}</h2>
        <p><small v-if="!value.trames.length">{{$t("soit")}} {{$t("$")}} {{format_number(value.estimation_m2)}} {{$t("€")}}/m²</small></p>
      </div>
      <div class="col-md-3 statB bb br">
          <b>{{$t("différence entre le bien et la commune")}}</b>
          <h2><span v-if="value.diff_bien_commune !== null">{{format_number(value.diff_bien_commune,true)}} %</span><span v-else class="small">{{nodata}}</span></h2>
      </div>
      <div class="col-md-3 statB bb br">
        <b class="mb-4 d-block">{{$t("Liquidité du bien par rapport au marché")}}</b>
        <div class="liquidite"><span class="pin" v-bind:style="{ left: (value.liquidite==0?10:(value.liquidite==1?45:85)) + '%' }"></span></div>
      </div>
      <div v-if="rights.rapport.eval_prix_ooftop_extra" class="col-md-3 statB bb">
        <b>{{$t("granularité commune")}}</b>
        <h2><span v-if="value.granularite_commune !== null">{{$t("$")}} {{format_number(value.granularite_commune)}} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
        <p><span v-if="value.granularite_commune_m2 !== null && value.granularite_commune_m2>0">{{$t("$")}} {{format_number(value.granularite_commune_m2)}} {{$t("€")}}/m²<br/>{{format_number(value.granularite_commune_nb)}} {{$t("transaction"+(value.granularite_commune_nb>1?"s":""))}}</span></p>
      </div>
      <div v-if="rights.rapport.eval_prix_ooftop_extra" class="col-md-3 statB br">
        <b>{{$t("granularité sections voisines")}}</b>
        <h2><span v-if="value.granularite_voisinage !== null">{{$t("$")}} {{format_number(value.granularite_voisinage)}} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
        <p><span v-if="value.granularite_voisinage_m2 !== null && value.granularite_voisinage_m2>0">{{$t("$")}} {{format_number(value.granularite_voisinage_m2)}} {{$t("€")}}/m²<br/>{{format_number(value.granularite_voisinage_nb)}} {{$t("transaction"+(value.granularite_voisinage_nb>1?"s":""))}}</span></p>
      </div>
      <div v-if="rights.rapport.eval_prix_ooftop_extra" class="col-md-3 statB br">
        <b>{{$t("granularité quartier")}}</b>
        <h2><span v-if="value.granularite_quartier !== null">{{$t("$")}} {{format_number(value.granularite_quartier)}} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
        <p><span v-if="value.granularite_quartier_m2 !== null && value.granularite_quartier_m2>0">{{$t("$")}} {{format_number(value.granularite_quartier_m2)}} {{$t("€")}}/m²<br/>{{format_number(value.granularite_quartier_nb)}} {{$t("transaction"+(value.granularite_quartier_nb>1?"s":""))}}</span></p>
      </div>
      <div v-if="rights.rapport.eval_prix_ooftop_extra" class="col-md-3 statB br">
        <b>{{$t("granularité section")}}</b>
        <h2><span v-if="value.granularite_section !== null">{{$t("$")}} {{format_number(value.granularite_section)}} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
        <p><span v-if="value.granularite_section_m2 !== null && value.granularite_section_m2>0">{{$t("$")}} {{format_number(value.granularite_section_m2)}} {{$t("€")}}/m²<br/>{{format_number(value.granularite_section_nb)}} {{$t("transaction"+(value.granularite_section_nb>1?"s":""))}}</span></p>
      </div>
      <div v-if="rights.rapport.eval_prix_ooftop_extra" class="col-md-3 statB">
        <b>{{$t("granularité parcelle")}}</b>
        <h2><span v-if="value.granularite_parcelle !== null">{{$t("$")}} {{format_number(value.granularite_parcelle)}} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
        <p><span v-if="value.granularite_parcelle_m2 !== null && value.granularite_parcelle_m2>0">{{$t("$")}} {{format_number(value.granularite_parcelle_m2)}} {{$t("€")}}/m²<br/>{{format_number(value.granularite_parcelle_nb)}} {{$t("transaction"+(value.granularite_parcelle_nb>1?"s":""))}}</span></p>
      </div>
    </div>
    <div v-if="rights.rapport.eval_prix_judiciaire && typeof value.judiciaire_adju_maison !== 'undefined'" class="row bg-blue bigText evalBlock mb-3">
      <div class="col-md-12 evalTitle">
        <h3>{{$t("Indicateur de")}} {{$t("ventes judiciaires")}}</h3>
      </div>
      <div class="col-md-3 statB bg-dark br bb">
        <b>{{$t("prix estimé")}}</b>
        <h2>{{$t("$")}} {{ format_number(value.judiciaire_prix) }} {{$t("€")}}</h2>
      </div>
      <div class="col-md-3 statB br bb">
        <b>{{$t("nombre d'adjudications")}}</b>
        <h2><span v-if="value.judiciaire_nb !== null">{{ format_number(value.judiciaire_nb) }}</span><span v-else class="small">{{nodata}}</span></h2>
      </div>
      <div class="col-md-3 statB br bb">
        <b>{{$t("nombre d'adjudications d'appartements")}}</b>
        <h2><span v-if="value.judiciaire_adju_appartement !== null">{{format_number(value.judiciaire_adju_appartement)}}</span><span v-else class="small">{{nodata}}</span></h2>
      </div>
      <div class="col-md-3 statB bb">
        <b>{{$t("nombre d'adjudications de maisons")}}</b>
        <h2><span v-if="value.judiciaire_adju_maison !== null">{{format_number(value.judiciaire_adju_maison)}}</span><span v-else class="small">{{nodata}}</span></h2>
      </div>
      <div class="col-md-3 statB br">
        <b>{{$t("prix moyen des appartements")}}</b>
        <h2><span v-if="value.judiciaire_pm_appartement !== null">{{$t("$")}} {{format_number(value.judiciaire_pm_appartement)}} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
        <p><small v-if="value.judiciaire_pm_appartement_m2 !== null">{{$t("soit")}} {{$t("$")}} {{format_number(value.judiciaire_pm_appartement_m2)}} {{$t("€")}}/m²</small></p> 
      </div>
      <div class="col-md-3 statB br">
        <b>{{$t("prix moyen des maisons")}}</b>
        <h2><span v-if="value.judiciaire_pm_maison !== null">{{$t("$")}} {{format_number(value.judiciaire_pm_maison)}} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
        <p><small v-if="value.judiciaire_pm_maison_m2 !== null">{{$t("soit")}} {{$t("$")}} {{format_number(value.judiciaire_pm_maison_m2)}} {{$t("€")}}/m²</small></p>
      </div>
    </div>
    <div v-else-if="rights.rapport.eval_prix_judiciaire" class="row bg-blue bigText evalBlock mb-3">
      <div class="col-md-12 evalTitle">
        <h3>{{$t("Indicateur de")}} {{$t("ventes judiciaires")}}</h3>
      </div>
      <div class="col-md-3 statB bg-dark br">
        <b>{{$t("prix estimé")}}</b>
        <h2>{{$t("$")}} {{ format_number(value.judiciaire_prix) }} {{$t("€")}}</h2>
        <p v-if="value.judiciaire_nb"><small v-if="value.judiciaire_prix_m2 !== null">{{$t("soit")}} {{$t("$")}} {{format_number(value.judiciaire_prix_m2)}} {{$t("€")}}/m²</small></p> 
        <p v-else><small>{{$t("Abattement pour vente forcée de")}} {{value.judiciaire_vv}} % {{$t("sur la valeur vénale")}}</small></p> 
      </div>
      <div class="col-md-3 statB br">
        <b>{{$t("nombre d'adjudications")}}</b>
        <h2><span v-if="value.judiciaire_nb !== null">{{ format_number(value.judiciaire_nb) }}</span><span v-else class="small">{{nodata}}</span></h2>
      </div>
      <div class="col-md-3 statB br">
        <b>{{$t("prix moyen")}}</b>
        <h2><span v-if="value.judiciaire_prix_moy !== null">{{$t("$")}} {{format_number(value.judiciaire_prix_moy)}} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
      </div>
      <div class="col-md-3 statB">
        <b>{{$t("surface moyenne")}}</b>
        <h2><span v-if="value.judiciaire_surface_moy !== null">{{format_number(value.judiciaire_surface_moy)}} m²</span><span v-else class="small">{{nodata}}</span></h2>
      </div>
    </div>
    
    <b-modal id="modal-ae" :title="$t('L\'analyse de l\'évaluateur Ooftop')" hide-footer v-if="value.trames.length">
      <div class="quote"><i class="fas fa-quote-left"></i><span v-html="value.trames[2].content"></span><i class="fas fa-quote-right"></i></div>
    </b-modal>
  </div>
</template>

<script>
import Gauge from '@/components/Gauge'
export default {
  name: 'EvaluationPrix',
  components: {Gauge},
  data() {
    return {
      nodata:this.$i18n.t('Données insuffisantes'),
    }
  },
  props:{
    value: Object,
    rights: Object,
    gmapkey : String,
  },
  watch: {
  },
  computed: {
  },
  methods: {
  },
  mounted(){
  }
}
</script>